export default __webpack_public_path__ + "static/media/Icon-zoomout.c6ffd014.svg";